import { MxCell, MxGraph } from 'controls/designer/mxGraphInterfaces';
import { DesignerStore } from 'controls/designer/designerStore';
import { executeUpdate } from 'controls/designer/utils';
import { newGuid } from 'tools/guid';

export class GraphManager {
	constructor(public store: DesignerStore) {}

	createHtmlShape(args: CreateHtmlShapeArgs) {
		return this.insertVertex({
			width: args.width,
			height: args.height,
			x: args.x,
			y: args.y,
			style:
				`shape=htmlContainerShape;verticalLabelPosition=bottom;verticalAlign=top;containerId=${newGuid()};` +
				(args.style ?? ''),
		});
	}

	insertVertex(args: InsertVertexArgs) {
		return this.store.legacyDesigner.graph.insertVertex(
			args.parent,
			args.id,
			args.value,
			args.x,
			args.y,
			args.width,
			args.height,
			args.style,
			args.relative,
		);
	}

	executeUpdate = (callback: (graph: MxGraph) => void) => {
		executeUpdate(this.store.graph, callback);
	};
}

type CreateHtmlShapeArgs = {
	x: number;
	y: number;
	width: number;
	height: number;
	style?: string;
};

type InsertVertexArgs = {
	parent?: MxCell;
	id?: string;
	value?: HTMLObjectElement | string;
	x: number;
	y: number;
	width: number;
	height: number;
	style?: string;
	relative?: boolean;
};
